import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-error-send-sms-modal',
  templateUrl: './error-send-sms-modal-component.html',
  styleUrls: ['./error-send-sms-modal-component.scss'],
})
export class ErrorSendSMSModalComponent {
  @Input() data;
  ctx;
  constructor(
    private modalCtrl: ModalController
  ) {
    this.ctx = this.data?.ctx;
  }

  onClose(): void {
    this.modalCtrl.dismiss();
  }

}
